module.exports = __webpack_public_path__ + "img/tutorial1.b04b7289.png";